import { render, staticRenderFns } from "./ExportarBase.vue?vue&type=template&id=11998d30&"
import script from "./ExportarBase.vue?vue&type=script&lang=js&"
export * from "./ExportarBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports